// Platform configuration
export const PLATFORMS = [
  { value: 'wordpress', label: 'WordPress' },
  { value: 'shopify', label: 'Shopify' },
]

// Get platform icon
export const getPlatformIcon = (platform) => {
  switch (platform) {
    case 'wordpress':
      return 'mdi:wordpress'
    case 'shopify':
      return 'logos:shopify'
    default:
      return 'mdi:web'
  }
}

// Get platform color
export const getPlatformColor = (platform) => {
  switch (platform) {
    case 'wordpress':
      return 'bg-[#21759b]'
    case 'shopify':
      return 'bg-[#96bf48]'
    default:
      return 'bg-primary'
  }
}

// Get connection status label
export const getConnectionStatusLabel = (connectionStatus) => {
  switch (connectionStatus) {
    case 'connected':
      return 'Connected'
    case 'error':
      return 'Connection Error'
    case 'pending':
      return 'Pending'
    default:
      return 'Unknown'
  }
}

// Get connection status badge classes
export const getConnectionStatusColor = (connectionStatus) => {
  switch (connectionStatus) {
    case 'connected':
      return 'bg-success/20 text-success'
    case 'error':
      return 'bg-danger/20 text-danger'
    case 'pending':
      return 'bg-warning/20 text-warning'
    default:
      return 'bg-text-secondary/20 text-text-secondary'
  }
}
